import React, { useEffect, useState } from 'react';
import './MockupCreator.css';
import formConfig from './formConfig.json';

const MockupCreator = ({ mockupImageUrl, logoUrl, width = '100%', height = '100%', clientId = 'default' }) => {
  console.log('MockupCreator: Rendering with mockupImageUrl:', mockupImageUrl, 'and logoUrl:', logoUrl);

  const [progress, setProgress] = useState(0);

  // Get the loadingText from formConfig, use default if not found
  const loadingText = formConfig[clientId]?.loadingText || formConfig.default.loadingText || "Creating Mockup";

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prevProgress + 10;
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="mockup-creator" style={{ width, height }}>
      <div className="mockup" style={{ backgroundImage: `url(${mockupImageUrl})` }}></div>
      <div className="blue-line"></div>
      {logoUrl && logoUrl !== 'undefined' && (
        <img src={logoUrl} alt="Logo" className="logo" />
      )}
      <div className="status-overlay">
        <div className="status-text">{loadingText}</div>
        <div className="progress-bar">
          <div className="progress" style={{ width: `${progress}%` }}></div>
        </div>
      </div>
    </div>
  );
};

export default MockupCreator;